import React from 'react';
import { Link } from "react-router-dom";
import logoComplexnetworksWhite from './img/logo-complex-networks-white.svg';

function Footer(props) {
    return (
        <footer id="footer">
            <div className="wrapper">
                <a href="https://www.complexnetworks.com" className="logo">
                    <img src={logoComplexnetworksWhite} alt="Complex Networks Logo" />
                </a>

                <div className="legal-links">
                    <a href="https://www.complexnetworks.com/#careers">CAREERS</a>
                    <Link to="/terms-and-conditions">TERMS OF USE</Link>
                    <a href="https://www.complexnetworks.com/privacy-policy/index.html">PRIVACY POLICY</a>
                    <button id="ot-sdk-btn" className="ot-sdk-show-settings link link--white link--underlined">Cookies Settings</button>
                </div>

                <div className="copiright">© Complex Networks. All Rights Reserved.</div>
            </div>
        </footer>
    );
}

export default Footer;
